import { useSelect, useDispatch } from '@wordpress/data';
import { Inserter } from '@wordpress/block-editor';
import { __, sprintf, _x } from '@wordpress/i18n';
import { Button, Icon, Tooltip } from '@wordpress/components';
import { applyFilters } from '@wordpress/hooks';
import { plus } from '@wordpress/icons';

export default function BlockAppender({ clientId, isSelected, attributes }) {
	const { isBlockPreview } = attributes;

	// Prevent render during preview
	if ( isBlockPreview ) {
		return null;
	}

	// Get block info and check for child blocks
	const block = useSelect((select) =>
		select('core/block-editor').getBlock(clientId), [clientId]
	);
	const innerBlocksCount = block ? block.innerBlocks.length : 0;
	const hasChildBlocks = innerBlocksCount > 0;

	const { selectBlock } = useDispatch('core/block-editor');

	function ButtonBlockAppender() {
		return (
			<Inserter
				position="bottom right"
				rootClientId={clientId}
				__experimentalIsQuick
				isAppender
				renderToggle={({
					onToggle,
					disabled,
					isOpen,
					blockTitle,
					hasSingleBlockType,
				}) => {
					const label = hasSingleBlockType
						? sprintf(
							_x('Add %s', 'directly add the only allowed block', 'vayu-blocks'),
							blockTitle
						)
						: _x('Add block', 'Generic label for block inserter button', 'vayu-blocks');

					return (
						<Tooltip text={label}>
							<Button
								className="block-editor-button-block-appender"
								onClick={onToggle}
								aria-haspopup={!hasSingleBlockType ? 'true' : undefined}
								aria-expanded={!hasSingleBlockType ? isOpen : undefined}
								disabled={disabled}
								label={label}
							>
								<Icon icon={plus} />
							</Button>
						</Tooltip>
					);
				}}
			/>
		);
	}

	let appender = null;

	if (isSelected || !hasChildBlocks) {
		appender = <ButtonBlockAppender />;
	}

	return applyFilters(
		'vayu-blocks.editor.containerAppender',
		appender,
		{ clientId, isSelected, attributes }
	);
}
